/**
 * `/super-admin/hq/automation` — two tabs (lifecycle-policy-contract.md §9):
 *   - Lifecycle (default): the nine built-in lifecycle emails — `LifecyclePolicyPanel`.
 *   - Custom rules: the generic trigger/action rule builder that used to be this whole
 *     page, moved verbatim to `CustomRulesPanel.jsx` when the Lifecycle tab was added.
 *
 * The outer `hq-automation` testId stays on THIS shell's root, the page's "is up" marker.
 * `CustomRulesPanel`'s own root is `hq-custom-rules`, so no id is ever rendered twice.
 */
import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useT } from "@/lib/LanguageContext";
import { LIFECYCLE } from "@/constants/testIds/lifecycle";
import LifecyclePolicyPanel from "@/super_admin/lifecycle/LifecyclePolicyPanel";
import CustomRulesPanel from "@/super_admin/CustomRulesPanel";

export default function HqAutomation() {
  const t = useT("superadmin");

  return (
    <div data-testid="hq-automation">
      <Tabs defaultValue="lifecycle">
        <TabsList data-testid={LIFECYCLE.tabs}>
          <TabsTrigger value="lifecycle" data-testid={LIFECYCLE.tabLifecycle}>
            {t("lifecycle.tabs.lifecycle")}
          </TabsTrigger>
          <TabsTrigger value="custom-rules" data-testid={LIFECYCLE.tabCustomRules}>
            {t("lifecycle.tabs.customRules")}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="lifecycle">
          <LifecyclePolicyPanel />
        </TabsContent>
        <TabsContent value="custom-rules">
          <CustomRulesPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
